import React, { useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { get } from 'lodash';
import { useLazyQuery } from '@apollo/client';

import Image from 'vibo-ui/Image';
import DefaultImagePlaceholder from 'vibo-ui/Image/DefaultImagePlaceholder';

import { ReactComponent as UserIcon } from 'resources/img/svg/common/user.svg';
import { ReactComponent as LogoHeadphonesIcon } from 'resources/img/svg/logoHeadphones.svg';

import { useMe } from 'graphql/hooks/user';
import { getFullName } from 'services/users/helpers';

import { GET_USER } from 'graphql/queries/user';

import { UserLogoProps } from './interfaces';

import useStyles from '../style';

const UserLogo = ({ user, className, onClick }: UserLogoProps) => {
  const classes = useStyles();

  const { isDj } = useMe();

  const [loadUser, { data: parentData }] = useLazyQuery(GET_USER, {
    fetchPolicy: 'cache-and-network',
  });
  const parent = get(parentData, 'user') as User;

  const alt = useMemo(() => (!!user ? getFullName(user) : ''), [user?.firstName, user?.lastName]);

  const parentId = get(user, 'djSettings.parentId', null);
  const logo = !!parent ? parent?.logoUrl : user?.logoUrl;

  useEffect(() => {
    !!parentId &&
      loadUser({
        variables: {
          userId: parentId,
        },
      });
  }, [parentId]);

  return (
    <Image
      onClick={onClick}
      src={logo as string}
      alt={alt}
      gradientId={user?._id}
      className={classNames(classes.img, className)}
    >
      <DefaultImagePlaceholder>
        {isDj ? <LogoHeadphonesIcon /> : <UserIcon />}
      </DefaultImagePlaceholder>
    </Image>
  );
};

export default UserLogo;
